export default Object.freeze({
  FormFieldAttachment: 1,
  GeneratedDocument: 2,
  VariableAttachment: 3,
});
